// ===================================================================
// KAIXO - LeaderboardIcon
// ===================================================================
// Corazón en contorno dorado — acceso al "Latido de la Fama".
// Sin relleno, trazo fino, elegante. Pensado para integrarse con el
// resto de iconos stroke de la app (ChainIcon, etc).
// ===================================================================

import React from 'react';

const GOLD = '#F5A000';

function LeaderboardIcon({ size = 20, color = GOLD }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ flexShrink: 0 }}
        >
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
    );
}

export default LeaderboardIcon;
